// libs/core/http/src/lib/http-core.module.ts
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BaseUrlInterceptor } from './interceptors/base-url.interceptor';
import { AuthBearerInterceptor } from './interceptors/auth-bearer.interceptor.class';

@NgModule({})
export class HttpCoreModule {
  static forRoot(): ModuleWithProviders<HttpCoreModule> {
    return {
      ngModule: HttpCoreModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: BaseUrlInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthBearerInterceptor,
          multi: true,
        },
      ],
    };
  }
}